import { Role } from '@/shared/roles/role';
import { User } from '@/shared/user';

export class State {
    public users: Array<User> = [];
    public legalAdvisorUsers: Array<User> = [];
    public appointmentBookerUsers: Array<User> = [];
    public interactionAuthorUsers: Array<User> = [];
    public assignedTaskUsers: Array<User> = [];
    public completedTaskUsers: Array<User> = [];
    public accountAuthorUsers: Array<User> = [];
    public assignedCallUsers: Array<User> = [];
    public accountAccessUsers: Array<User> = [];
    public targetUsers: Array<User> = [];
    public roles: Array<Role> = [];
}
